import { createUseStyles } from 'react-jss'
import { mediumGrey } from '../../../../styles/const/colors'
import { phonesDown } from '../../../../styles/const/breakpoints'

const useStyles = createUseStyles({
  pageDateRange: {
    // On mobile we don't show dateRange, we show static dateList instead,
    // If user select 'custom' - then we open dateRange
    '& [class*="control"]': {
      minHeight: 37,
      maxHeight: 37
    },
    [`@media screen and (${phonesDown})`]: {
      display: 'none'
    }
  },
  calendarIcon: {
    marginLeft: 10,
    color: mediumGrey,
    width: 18,
    [`@media screen and (${phonesDown})`]: {
      width: 16
    }
  }
})

export default useStyles
